module.exports = __webpack_public_path__ + "img/IMerchantTransport64_ua.b6812d32.webp";